import { Component, inject, output } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { appConfig } from '../../../assets/config/app.config';
import { NavigationItem } from '../../shared/models/navigation-item';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';

@Component({
    selector: 'app-navigation-menu',
    templateUrl: './navigation-menu.component.html',
    styleUrls: ['./navigation-menu.component.scss'],
    imports: [TranslateModule, MatIconModule, MatListModule, RouterLink],
    standalone: true
})
export class NavigationMenuComponent {
  readonly router = inject(Router);

  readonly closeSidenav = output<boolean>();

  readonly navigationItems: NavigationItem[] = appConfig.navigation.items;

  stopPropagation(event): void {
    event.stopPropagation();
  }

  onSelectItem(route: string) {
    this.closeSidenav.emit(true);
    this.router.navigate([route]);
  }
}
